import { Modal } from 'react-bootstrap';

// Images
import Logo from 'Assets/images/logo.png';

export default (props) => {
  const handleIconClick = (i) => {
    props.setselectedIcon(i + 1);
    props.onHide();
  };

  return (
    <Modal {...props} size="lg" centered className="strategy-icons-modal" animation={false}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <div>
          <img src={Logo} alt="logo" className="logo" />
        </div>
        <div className="mt-3">
          <p className="color-white">Please select icon</p>
          <div className="icons">
            {[...Array(50)].map((num, i) => (
              <div key={num}>
                {/* eslint-disable */}
                <img
                  src={require(`../../../../Assets/images/icons/strategy/Artboard ${i + 1}.png`).default}
                  alt="icon"
                  height={80}
                  width={80}
                  onClick={() => handleIconClick(i)}
                  className="cursor-pointer"
                />
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
